import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'

const originalPush = Router.prototype.push

Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    return savedPosition || { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'index',
      component: resolve => {
        if (store.getters.getTemplateType === 1) {
          return require(['../views/mine/certificationNew.vue'], resolve)
        } else {
          return require(['../views/mine/certification.vue'], resolve)
        }
      },
      meta: {
        title: '账号认证',
        keepAlive: true,
        fromRouterkeepAlive: []
      }
    },
    {
      path: '/certification',
      name: 'certification',
      component: resolve => {
        if (store.getters.getTemplateType === 1) {
          return require(['../views/mine/certificationNew.vue'], resolve)
        } else {
          return require(['../views/mine/certification.vue'], resolve)
        }
      },
      meta: {
        title: '账号认证',
        fromRouterkeepAlive: []
      }
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => {
        if (store.getters.getTemplateType === 1) {
          return require(['../views/mine/loginNew.vue'], resolve)
        } else {
          return require(['../views/mine/login.vue'], resolve)
        }
      },
      // component: resolve => require(['../views/mine/login.vue'], resolve),
      meta: {
        title: '登录'
      }
    },
    {
      path: '/home',
      name: 'home',
      component: resolve => {
        if (store.getters.getTemplateType === 1) {
          return require(['../views/home/indexNew.vue'], resolve)
        } else {
          return require(['../views/home/index.vue'], resolve)
        }
      },
      meta: {
        title: '首页',
        fromRouterkeepAlive: []
      }
    },
    {
      path: '/list',
      name: 'active',
      component: resolve => {
        if (store.getters.getTemplateType === 1) {
          return require(['../views/active/activeNew.vue'], resolve)
        } else {
          return require(['../views/active/active.vue'], resolve)
        }
      },

      meta: {
        title: '活动',
        fromRouterkeepAlive: []
      }
    },
    {
      path: '/activeSmsDetail',
      name: 'activeSmsDetail',
      component: resolve => require(['../views/active/activeSmsDetail.vue'], resolve),
      meta: {
        title: '短信活动',
        keepAlive: true,
        fromRouterkeepAlive: [
          'showImg'
        ]
      }
    },
    {
      path: '/activeDetail',
      name: 'activeDetail',
      component: resolve => require(['../views/active/activeDetail.vue'], resolve),
      meta: {
        title: '活动详情',
        keepAlive: true,
        fromRouterkeepAlive: []
      }
    },

    {
      path: '/mjx-activeDetail',
      name: 'mjx-activeDetail',
      component: resolve => require(['../views/active/mjx/mjx-activeDetail.vue'], resolve),
      meta: {
        title: '晒图活动详情',
        keepAlive: true,
        fromRouterkeepAlive: []
      }
    },

    {
      path: '/msg',
      name: 'message',
      component: resolve => require(['../views/message/message.vue'], resolve),
      meta: {
        title: '消息'
      }
    },
    {
      path: '/merchantMessageDetail',
      name: 'merchantMessageDetail',
      component: resolve => require(['../views/message/merchantMessageDetail.vue'], resolve),
      meta: {
        title: '商家通知详情'
      }
    },
    {
      path: '/systemMessageDetail',
      name: 'systemMessageDetail',
      component: resolve => require(['../views/message/systemMessageDetail.vue'], resolve),
      meta: {
        title: '系统通知详情'
      }
    },
    {
      path: '/mine',
      name: 'mine',

      component: resolve => require(['../views/mine/mine.vue'], resolve),
      meta: {
        title: '我的',
        fromRouterkeepAlive: []
      }
    }, {
      path: '/mine2',
      name: 'mine2',
      component: resolve => {
        if (store.getters.getTemplateType === 1) {
          return require(['../views/mine/mineNew.vue'], resolve)
        } else {
          return require(['../views/mine/mine.vue'], resolve)
        }
      },
      // component: resolve => require(['../views/mine/mineNew.vue'], resolve),
      meta: {
        title: '我的',
        fromRouterkeepAlive: []
      }
    },

    {
      path: '/test',
      name: 'test',
      component: resolve => require(['../views/mine/test.vue'], resolve),
      meta: {
        title: 'test',
        fromRouterkeepAlive: []
      }
    },

    {
      path: '/rejectLocation',
      name: 'rejectLocation',
      component: resolve => require(['../views/common/rejectLocation.vue'], resolve),
      meta: {
        title: '拒绝定位',
        keepAlive: true
      }
    },
    {
      path: '/userCenter',
      name: 'userCenter',
      component: resolve => require(['../views/mine/userCenter.vue'], resolve),
      meta: {
        title: '用户中心',
        keepAlive: true,
        fromRouterkeepAlive: []
      }
    },
    {
      path: '/updateCredit',
      name: 'updateCredit',
      component: resolve => require(['../views/mine/updateCredit.vue'], resolve),
      meta: {
        title: '更新淘气值'
      }
    },
    {
      path: '/myReward',
      name: 'myReward',
      component: resolve => {
        if (store.getters.getTemplateType === 1) {
          return require(['../views/mine/myRewardNew.vue'], resolve)
        } else {
          return require(['../views/mine/myReward.vue'], resolve)
        }
      },
      // component: resolve => require(['../views/mine/myReward.vue'], resolve),
      meta: {
        title: '我的奖励'
      }
    },
    {
      path: '/withdraw',
      name: 'withdraw',
      component: resolve => {
        if (store.getters.getTemplateType === 1) {
          return require(['../views/mine/myReward/withdrawNew.vue'], resolve)
        } else {
          return require(['../views/mine/myReward/withdraw.vue'], resolve)
        }
      },
      // component: resolve => require(['../views/mine/myReward/withdraw.vue'], resolve),
      meta: {
        title: '提现'
      }
    },
    {
      path: '/setting',
      name: 'setting',
      component: resolve => require(['../views/mine/setting.vue'], resolve),
      meta: {
        title: '设置'
      }
    },
    {
      path: '/share',
      name: 'share',
      component: resolve => require(['../views/mine/share.vue'], resolve),
      meta: {
        title: '分享',
        keepAlive: true
      }
    },
    {
      path: '/invitedRecord',
      name: 'invitedRecord',
      component: resolve => {
        if (store.getters.getTemplateType === 1) {
          return require(['../views/mine/invitedRecordNew.vue'], resolve)
        } else {
          return require(['../views/mine/invitedRecord.vue'], resolve)
        }
      },
      // component: resolve => require(['../views/mine/invitedRecord.vue'], resolve),
      meta: {
        title: '邀请记录'
      }
    },
    {
      path: '/showImg',
      name: 'showImg',
      component: resolve => require(['../views/common/showImg.vue'], resolve),
      meta: {
        title: '预览图片',
        keepAlive: true
      }
    },
    {
      path: '/showVideo',
      name: 'showVideo',
      component: resolve => require(['../views/common/showVideo.vue'], resolve),
      meta: {
        title: '预览视频',
        keepAlive: true
      }
    },
    {
      path: '/personalQrcode',
      name: 'personalQrcode',
      component: resolve => require(['../views/mine/personalQrCode.vue'], resolve),
      meta: {
        title: '个人专属二维码',
        keepAlive: true
      }
    },
    {
      path: '/blackState',
      name: 'blackState',
      component: resolve => require(['../views/mine/blackState.vue'], resolve),
      meta: {
        title: '被拉黑'
        // keepAlive: true
      }
    }

  ]
})

router.beforeEach((to, from, next) => {
  // if (to.meta.keepAlive && to.meta.fromRouterkeepAlive) {
  //   if (to.meta.fromRouterkeepAlive.indexOf(from.name) === -1 && from.name !== 'showImg') {
  //     store.commit('refresh')
  //   }
  // }
  // if (to.query.token) {
  //   next()
  //   return
  // };
  // if (from.query.token) {
  //   let toQuery = JSON.parse(JSON.stringify(to.query))
  //   toQuery.token = from.query.token
  //   next({
  //     path: to.path,
  //     query: toQuery
  //   })
  // } else {
  //   next()
  // }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js